import TextField from "@components/atoms/input";
import { Box, Select as MuiSelect, SelectProps } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import MuiCard from "@mui/material/Card";
import MuiCardContent from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  z-index: 1;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const GamesContainer = styled(Box)`
  display: flex;
  height: 100%;
  overflow: auto;
  padding: 16px 0px;
  flex-direction: column;
  gap: 16px;
`;

export const ProfileCard = styled(MuiCard)`
  z-index: 2;
  width: 100%;
  border: 1px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  ${(props) => props.theme.breakpoints.up("mobile")} {
    width: 50%;
  }
`;

export const CardContent = styled(MuiCardContent)`
  padding: 14px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Avatar = styled(MuiAvatar)`
  background-color: #a0aec0;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  color: ${(props) => props.theme.text.primary};
  text-align: center;
  font-size: 14px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const ProfileWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserNameAndProfileTagWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const UserName = styled(Typography)`
  color: ${(props) => props.theme.text.primary};
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const ViewProfileTag = styled(Typography)`
  color: #718096;
  font-size: 14px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const HeaderTitle = styled(Typography)`
  color: ${(props) => props.theme.text.light};
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const Title = styled(Typography)`
  color: #1d1d1d;
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const NoGamesTypography = styled(Typography)`
  color: var(--colours-grey-500, #718096);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: calc(100% - 64px - 0px);
  transform: translateY(-20px);
`;

export const ContentHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  max-height: calc(100% - 40px);
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Select = styled(MuiSelect)<SelectProps>`
  height: 32px;
  width: 81px;
`;

export const NoGamesWrapper = styled(Box)`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const CalendarContainer = styled(Box)`
  display: flex;
  min-height: 75px;
  height: 70px;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar on IE and Edge */
  -ms-overflow-style: none;

  /* Hide scrollbar on Firefox */
  scrollbar-width: none;

  /* Firefox specific */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Wrapper = styled(Box)`
  display: flex;
  min-height: 75px;
  height: 70px;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar on IE and Edge */
  -ms-overflow-style: none;

  /* Hide scrollbar on Firefox */
  scrollbar-width: none;

  /* Firefox specific */
  &::-webkit-scrollbar {
    display: none;
  }
`;
